
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableSortLabel,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   LocalHospital as HealthIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
//   Pets as AnimalIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const HealthRecordsPage = () => {
//   const navigate = useNavigate();
//   const [healthRecords, setHealthRecords] = useState([]);
//   const [filteredRecords, setFilteredRecords] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     animal_id: "",
//     diagnosis: ""
//   });

//   // Dialogs
//   const [showFilters, setShowFilters] = useState(false);
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [openViewDialog, setOpenViewDialog] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState(null);

//   // Form Data
//   const [healthForm, setHealthForm] = useState({
//     animal_id: "",
//     diagnosis: "",
//     treatment: "",
//     vet_name: "",
//     follow_up_date: "",
//     date: new Date().toISOString().split('T')[0]
//   });

//   const [animals, setAnimals] = useState([]);

//   const API_URL = "https://dairy.server.statify.co.ke/api/health-records";

//   // Helper function to format date for form input
//   const formatDateForInput = (dateString) => {
//     if (!dateString) return new Date().toISOString().split('T')[0];
    
//     try {
//       // Try parsing the date string - handle various formats
//       const date = new Date(dateString);
      
//       // Check if date is valid
//       if (isNaN(date.getTime())) {
//         console.warn('Invalid date:', dateString);
//         return new Date().toISOString().split('T')[0];
//       }
      
//       return date.toISOString().split('T')[0];
//     } catch (error) {
//       console.error('Error formatting date:', error, dateString);
//       return new Date().toISOString().split('T')[0];
//     }
//   };

//   // Table Columns for Virtualized Table
//   const columns = [
//     { width: 120, label: 'Animal ID', dataKey: 'animal_id' },
//     { width: 150, label: 'Animal Name', dataKey: 'animal_name' },
//     { width: 200, label: 'Diagnosis', dataKey: 'diagnosis' },
//     { width: 150, label: 'Vet Name', dataKey: 'vet_name' },
//     { width: 120, label: 'Record Date', dataKey: 'date' },
//     { width: 120, label: 'Follow-up', dataKey: 'follow_up_date' },
//     { width: 120, label: 'Status', dataKey: 'status' },
//     { width: 200, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Fetch Health Records
//   const fetchHealthRecords = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(API_URL);
//       const data = await res.json();
      
//       if (Array.isArray(data)) {
//         // Transform data to include animal names and status
//         const transformedRecords = await Promise.all(
//           data.map(async (record) => {
//             let animalName = "Unknown";
//             try {
//               const animalRes = await fetch(`https://dairy.server.statify.co.ke/api/animals/${record.animal_id}`);
//               if (animalRes.ok) {
//                 const animalData = await animalRes.json();
//                 animalName = animalData.name || `Animal ${record.animal_id}`;
//               }
//             } catch (err) {
//               console.error('Error fetching animal details:', err);
//             }

//             // Format dates for display
//             let displayDate = "Invalid Date";
//             let followUpDisplay = 'No follow-up';
            
//             try {
//               const recordDate = new Date(record.date);
//               if (!isNaN(recordDate.getTime())) {
//                 displayDate = recordDate.toLocaleDateString();
//               }
//             } catch (err) {
//               console.error('Error formatting record date:', err);
//             }

//             let status = "Completed";
//             let statusColor = "success";

//             if (record.follow_up_date) {
//               try {
//                 const followUpDate = new Date(record.follow_up_date);
//                 if (!isNaN(followUpDate.getTime())) {
//                   followUpDisplay = followUpDate.toLocaleDateString();
//                   const now = new Date();
                  
//                   if (followUpDate > now) {
//                     status = "Pending";
//                     statusColor = "warning";
//                   } else {
//                     status = "Overdue";
//                     statusColor = "error";
//                   }
//                 }
//               } catch (err) {
//                 console.error('Error processing follow-up date:', err);
//               }
//             }

//             return {
//               ...record,
//               animal_name: animalName,
//               status: status,
//               status_color: statusColor,
//               date: displayDate,
//               follow_up_date: followUpDisplay,
//               short_treatment: record.treatment ? 
//                 (record.treatment.length > 50 ? `${record.treatment.substring(0, 50)}...` : record.treatment) 
//                 : 'No treatment',
//               originalDate: record.date, // Keep original date for editing
//               originalFollowUpDate: record.follow_up_date // Keep original follow-up date for editing
//             };
//           })
//         );
//         setHealthRecords(transformedRecords);
//       } else {
//         setHealthRecords([]);
//       }
//     } catch (err) {
//       console.error('Error fetching health records:', err);
//       swal("Error", "Failed to fetch health records", "error");
//       setHealthRecords([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch Animals for Dropdown
//   const fetchAnimals = async () => {
//     try {
//       const res = await fetch("https://dairy.server.statify.co.ke/api/animals");
//       const data = await res.json();
//       if (data.animals && Array.isArray(data.animals)) {
//         setAnimals(data.animals);
//       } else if (Array.isArray(data)) {
//         setAnimals(data);
//       }
//     } catch (err) {
//       console.error('Error fetching animals:', err);
//     }
//   };

//   useEffect(() => {
//     fetchHealthRecords();
//     fetchAnimals();
//   }, []);

//   // Filter records based on search and filters
//   useEffect(() => {
//     if (!Array.isArray(healthRecords)) {
//       setFilteredRecords([]);
//       return;
//     }
    
//     let results = healthRecords;

//     // Apply search term
//     if (searchTerm) {
//       results = results.filter(record =>
//         (record.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (record.diagnosis?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (record.vet_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (record.treatment?.toLowerCase() || '').includes(searchTerm.toLowerCase())
//       );
//     }

//     // Apply animal filter
//     if (filters.animal_id) {
//       results = results.filter(record => 
//         record.animal_id.toString() === filters.animal_id
//       );
//     }

//     // Apply diagnosis filter
//     if (filters.diagnosis) {
//       results = results.filter(record => 
//         record.diagnosis.toLowerCase().includes(filters.diagnosis.toLowerCase())
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
        
//         if (aVal === null || aVal === undefined) return 1;
//         if (bVal === null || bVal === undefined) return -1;
        
//         if (sortConfig.key === 'date' || sortConfig.key === 'follow_up_date') {
//           try {
//             const aDate = new Date(sortConfig.key === 'date' ? a.originalDate : a.originalFollowUpDate);
//             const bDate = new Date(sortConfig.key === 'date' ? b.originalDate : b.originalFollowUpDate);
            
//             if (isNaN(aDate.getTime()) || isNaN(bDate.getTime())) return 0;
            
//             return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
//           } catch (err) {
//             return 0;
//           }
//         }
        
//         if (typeof aVal === 'string' && typeof bVal === 'string') {
//           return sortConfig.direction === 'asc' 
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }
        
//         if (aVal < bVal) {
//           return sortConfig.direction === 'asc' ? -1 : 1;
//         }
//         if (aVal > bVal) {
//           return sortConfig.direction === 'asc' ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     setFilteredRecords(results);
//   }, [healthRecords, searchTerm, filters, sortConfig]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       animal_id: "",
//       diagnosis: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   };

//   // Form Handlers
//   const handleFormChange = (field, value) => {
//     setHealthForm(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const resetForm = () => {
//     setHealthForm({
//       animal_id: "",
//       diagnosis: "",
//       treatment: "",
//       vet_name: "",
//       follow_up_date: "",
//       date: new Date().toISOString().split('T')[0]
//     });
//   };

//   // Create Health Record
//   const handleCreateHealthRecord = async () => {
//     if (!healthForm.animal_id || !healthForm.diagnosis) {
//       swal("Error", "Animal and diagnosis are required", "error");
//       return;
//     }

//     try {
//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...healthForm,
//           animal_id: parseInt(healthForm.animal_id)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Health record created successfully!", "success");
//         setOpenCreateDialog(false);
//         resetForm();
//         fetchHealthRecords();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Update Health Record
//   const handleUpdateHealthRecord = async () => {
//     if (!selectedRecord) return;

//     try {
//       const res = await fetch(`${API_URL}/${selectedRecord.id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           ...healthForm,
//           animal_id: parseInt(healthForm.animal_id)
//         }),
//       });

//       const data = await res.json();
//       if (res.ok) {
//         swal("Success", "Health record updated successfully!", "success");
//         setOpenEditDialog(false);
//         setSelectedRecord(null);
//         resetForm();
//         fetchHealthRecords();
//       } else {
//         swal("Error", data.error, "error");
//       }
//     } catch (err) {
//       swal("Error", "Something went wrong", "error");
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (recordId) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the health record!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${recordId}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           fetchHealthRecords();
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // View Handler
//   const handleView = (record) => {
//     setSelectedRecord(record);
//     setOpenViewDialog(true);
//   };

//   // Open Edit Dialog - FIXED VERSION
//   const handleEdit = (record) => {
//     setSelectedRecord(record);
    
//     // Use the helper function to safely format the dates
//     const formattedDate = formatDateForInput(record.originalDate || record.date);
//     const formattedFollowUpDate = formatDateForInput(record.originalFollowUpDate || record.follow_up_date);
    
//     setHealthForm({
//       animal_id: record.animal_id.toString(),
//       diagnosis: record.diagnosis,
//       treatment: record.treatment || "",
//       vet_name: record.vet_name || "",
//       follow_up_date: record.follow_up_date !== 'No follow-up' ? formattedFollowUpDate : "",
//       date: formattedDate
//     });
//     setOpenEditDialog(true);
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: 'error.main', 
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           <TableSortLabel
//             active={sortConfig.key === column.dataKey}
//             direction={sortConfig.direction}
//             onClick={() => handleSort(column.dataKey)}
//             sx={{ color: 'white !important' }}
//           >
//             {column.label}
//           </TableSortLabel>
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, record) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {record.animal_id}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {record.animal_name}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap title={record.diagnosis}>
//           {record.diagnosis}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {record.vet_name || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {record.date}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {record.follow_up_date}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={record.status} 
//           size="small"
//           color={record.status_color}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             color="info"
//             onClick={() => handleView(record)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="primary"
//             onClick={() => handleEdit(record)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(record.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'error.dark' }}>
//         <Toolbar>
//           <HealthIcon sx={{ mr: 2 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Health Records
//           </Typography>
//           <Chip 
//             label={`${healthRecords.length} Records`} 
//             color="primary" 
//             variant="filled"
//             sx={{ color: 'white', fontWeight: 'bold', mr: 2 }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={() => setOpenCreateDialog(true)}
//             sx={{ borderRadius: 2, backgroundColor: 'success.main' }}
//           >
//             New Health Record
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: 'error.light' }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search by animal name, diagnosis, vet name..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     color="error"
//                   >
//                     Filters
//                   </Button>
//                   <Button onClick={resetFilters} variant="outlined" size="small" color="error">
//                     Reset
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={4}>
//                     <FormControl
//   fullWidth
//   sx={{
//     minWidth: 250, // ensures the field isn’t too narrow
//   }}
// >
//   <InputLabel id="animal-select-label">Animal</InputLabel>
//   <Select
//     labelId="animal-select-label"
//     value={filters.animal_id}
//     onChange={(e) => handleFilterChange('animal_id', e.target.value)}
//     label="Animal"
//     sx={{
//       width: '100%',
//       whiteSpace: 'nowrap',
//     }}
//   >
//     <MenuItem value="">All Animals</MenuItem>
//     {animals.map((animal) => (
//       <MenuItem key={animal.id} value={animal.id.toString()}>
//         {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
//       </MenuItem>
//     ))}
//   </Select>
// </FormControl>

//                   </Grid>

//                   <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       label="Diagnosis"
//                       value={filters.diagnosis}
//                       onChange={(e) => handleFilterChange('diagnosis', e.target.value)}
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
            
            
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress color="error" />
//               </Box>
//             ) : filteredRecords.length === 0 ? (
//               <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: 'error.light' }}>
//                 <CardContent>
//                   <AnimalIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
//                   <Typography variant="h5" color="error.main" gutterBottom>
//                     No health records found
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     Start tracking your herd's health by recording diagnoses and treatments
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     color="error" 
//                     onClick={() => setOpenCreateDialog(true)} 
//                     size="large"
//                   >
//                     Create First Record
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: 'error.light', borderRadius: 1 }}>
//                 <TableVirtuoso
//                   data={filteredRecords}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Create Health Record Dialog */}
//       <Dialog 
//         open={openCreateDialog} 
//         onClose={() => setOpenCreateDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <AddIcon sx={{ mr: 1 }} />
//             Create New Health Record
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             <Grid item xs={12} sm={6}>
//               <FormControl
//   fullWidth
//   sx={{
//     minWidth: { xs: '100%', sm: 250, md: 300 }, // responsive width
//   }}
// >
//   <InputLabel id="animal-select-label">Animal *</InputLabel>
//   <Select
//     labelId="animal-select-label"
//     value={healthForm.animal_id}
//     onChange={(e) => handleFormChange('animal_id', e.target.value)}
//     label="Animal *"
//     sx={{
//       width: '100%',
//       whiteSpace: 'nowrap',
//     }}
//   >
//     {animals.map((animal) => (
//       <MenuItem key={animal.id} value={animal.id.toString()}>
//         {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
//       </MenuItem>
//     ))}
//   </Select>
// </FormControl>

//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Record Date"
//                 type="date"
//                 value={healthForm.date}
//                 onChange={(e) => handleFormChange('date', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Diagnosis *"
//                 value={healthForm.diagnosis}
//                 onChange={(e) => handleFormChange('diagnosis', e.target.value)}
//                 placeholder="Enter the diagnosis or health issue..."
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Treatment"
//                 placeholder="Describe the treatment plan, medications, and procedures..."
//                 value={healthForm.treatment}
//                 onChange={(e) => handleFormChange('treatment', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Veterinarian Name"
//                 placeholder="Dr. Smith"
//                 value={healthForm.vet_name}
//                 onChange={(e) => handleFormChange('vet_name', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Follow-up Date"
//                 type="date"
//                 value={healthForm.follow_up_date}
//                 onChange={(e) => handleFormChange('follow_up_date', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//                 helperText="Optional follow-up appointment"
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenCreateDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleCreateHealthRecord} 
//             variant="contained" 
//             color="success"
//             disabled={!healthForm.animal_id || !healthForm.diagnosis}
//           >
//             Create Record
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Health Record Dialog */}
//       <Dialog 
//         open={openEditDialog} 
//         onClose={() => setOpenEditDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <EditIcon sx={{ mr: 1 }} />
//             Edit Health Record
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Grid container spacing={3} sx={{ mt: 1 }}>
//             <Grid item xs={12} sm={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Animal *</InputLabel>
//                 <Select
//                   value={healthForm.animal_id}
//                   onChange={(e) => handleFormChange('animal_id', e.target.value)}
//                   label="Animal *"
//                 >
//                   {animals.map(animal => (
//                     <MenuItem key={animal.id} value={animal.id.toString()}>
//                       {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Record Date"
//                 type="date"
//                 value={healthForm.date}
//                 onChange={(e) => handleFormChange('date', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Diagnosis *"
//                 value={healthForm.diagnosis}
//                 onChange={(e) => handleFormChange('diagnosis', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Treatment"
//                 value={healthForm.treatment}
//                 onChange={(e) => handleFormChange('treatment', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Veterinarian Name"
//                 value={healthForm.vet_name}
//                 onChange={(e) => handleFormChange('vet_name', e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <TextField
//                 fullWidth
//                 label="Follow-up Date"
//                 type="date"
//                 value={healthForm.follow_up_date}
//                 onChange={(e) => handleFormChange('follow_up_date', e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
//           <Button 
//             onClick={handleUpdateHealthRecord} 
//             variant="contained" 
//             color="primary"
//             disabled={!healthForm.animal_id || !healthForm.diagnosis}
//           >
//             Update Record
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* View Health Record Dialog */}
//       <Dialog 
//         open={openViewDialog} 
//         onClose={() => setOpenViewDialog(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               <ViewIcon sx={{ mr: 1 }} />
//               Health Record Details
//             </Box>
//             <IconButton onClick={() => setOpenViewDialog(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           {selectedRecord && (
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Animal Information
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Animal ID:</strong> {selectedRecord.animal_id}
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Animal Name:</strong> {selectedRecord.animal_name}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
              
//               <Grid item xs={12} sm={6}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Record Details
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Date:</strong> {selectedRecord.date}
//                     </Typography>
//                     <Typography variant="body2" sx={{ mb: 1 }}>
//                       <strong>Veterinarian:</strong> {selectedRecord.vet_name || 'Not specified'}
//                     </Typography>
//                     <Typography variant="body2">
//                       <strong>Status:</strong> 
//                       <Chip 
//                         label={selectedRecord.status} 
//                         size="small"
//                         color={selectedRecord.status_color}
//                         sx={{ ml: 1 }}
//                       />
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Diagnosis
//                     </Typography>
//                     <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
//                       {selectedRecord.diagnosis}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12}>
//                 <Card variant="outlined">
//                   <CardContent>
//                     <Typography variant="h6" gutterBottom color="primary">
//                       Treatment
//                     </Typography>
//                     <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
//                       {selectedRecord.treatment || 'No treatment recorded'}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {selectedRecord.follow_up_date !== 'No follow-up' && (
//                 <Grid item xs={12}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <Typography variant="h6" gutterBottom color="primary">
//                         Follow-up Information
//                       </Typography>
//                       <Typography variant="body2">
//                         <strong>Follow-up Date:</strong> {selectedRecord.follow_up_date}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               )}
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Add FAB for mobile */}
//       <Fab
//         color="error"
//         aria-label="add"
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' }
//         }}
//         onClick={() => setOpenCreateDialog(true)}
//       >
//         <AddIcon />
//       </Fab>
//     </Box>
//   );
// };

// export default HealthRecordsPage;


import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Close as CloseIcon,
  LocalHospital as HealthIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
  Pets as AnimalIcon,
} from "@mui/icons-material";
import { TableVirtuoso } from "react-virtuoso";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Color constants
const PRIMARY_COLOR = '#024A59';
const SECONDARY_COLOR = '#FFA916';
const PRIMARY_LIGHT = '#346875';
const PRIMARY_DARK = '#013440';

// Virtualized Table Components
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow: (props) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

const HealthRecordsPage = () => {
  const navigate = useNavigate();
  const [healthRecords, setHealthRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Filters and Search
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filters, setFilters] = useState({
    animal_id: "",
    diagnosis: ""
  });

  // Dialogs
  const [showFilters, setShowFilters] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  // Form Data
  const [healthForm, setHealthForm] = useState({
    animal_id: "",
    diagnosis: "",
    treatment: "",
    vet_name: "",
    follow_up_date: "",
    date: new Date().toISOString().split('T')[0]
  });

  const [animals, setAnimals] = useState([]);

  const API_URL = "https://dairy.server.statify.co.ke/api/health-records";

  // Helper function to format date for form input
  const formatDateForInput = (dateString) => {
    if (!dateString) return new Date().toISOString().split('T')[0];
    
    try {
      // Try parsing the date string - handle various formats
      const date = new Date(dateString);
      
      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.warn('Invalid date:', dateString);
        return new Date().toISOString().split('T')[0];
      }
      
      return date.toISOString().split('T')[0];
    } catch (error) {
      console.error('Error formatting date:', error, dateString);
      return new Date().toISOString().split('T')[0];
    }
  };

  // Table Columns for Virtualized Table
  const columns = [
    { width: 120, label: 'Animal ID', dataKey: 'animal_id' },
    { width: 150, label: 'Animal Name', dataKey: 'animal_name' },
    { width: 200, label: 'Diagnosis', dataKey: 'diagnosis' },
    { width: 150, label: 'Vet Name', dataKey: 'vet_name' },
    { width: 120, label: 'Record Date', dataKey: 'date' },
    { width: 120, label: 'Follow-up', dataKey: 'follow_up_date' },
    { width: 120, label: 'Status', dataKey: 'status' },
    { width: 200, label: 'Actions', dataKey: 'actions' },
  ];

  // Fetch Health Records
  const fetchHealthRecords = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      
      if (Array.isArray(data)) {
        // Transform data to include animal names and status
        const transformedRecords = await Promise.all(
          data.map(async (record) => {
            let animalName = "Unknown";
            try {
              const animalRes = await fetch(`https://dairy.server.statify.co.ke/api/animals/${record.animal_id}`);
              if (animalRes.ok) {
                const animalData = await animalRes.json();
                animalName = animalData.name || `Animal ${record.animal_id}`;
              }
            } catch (err) {
              console.error('Error fetching animal details:', err);
            }

            // Format dates for display
            let displayDate = "Invalid Date";
            let followUpDisplay = 'No follow-up';
            
            try {
              const recordDate = new Date(record.date);
              if (!isNaN(recordDate.getTime())) {
                displayDate = recordDate.toLocaleDateString();
              }
            } catch (err) {
              console.error('Error formatting record date:', err);
            }

            let status = "Completed";
            let statusColor = "success";

            if (record.follow_up_date) {
              try {
                const followUpDate = new Date(record.follow_up_date);
                if (!isNaN(followUpDate.getTime())) {
                  followUpDisplay = followUpDate.toLocaleDateString();
                  const now = new Date();
                  
                  if (followUpDate > now) {
                    status = "Pending";
                    statusColor = "warning";
                  } else {
                    status = "Overdue";
                    statusColor = "error";
                  }
                }
              } catch (err) {
                console.error('Error processing follow-up date:', err);
              }
            }

            return {
              ...record,
              animal_name: animalName,
              status: status,
              status_color: statusColor,
              date: displayDate,
              follow_up_date: followUpDisplay,
              short_treatment: record.treatment ? 
                (record.treatment.length > 50 ? `${record.treatment.substring(0, 50)}...` : record.treatment) 
                : 'No treatment',
              originalDate: record.date, // Keep original date for editing
              originalFollowUpDate: record.follow_up_date // Keep original follow-up date for editing
            };
          })
        );
        setHealthRecords(transformedRecords);
      } else {
        setHealthRecords([]);
      }
    } catch (err) {
      console.error('Error fetching health records:', err);
      swal("Error", "Failed to fetch health records", "error");
      setHealthRecords([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Animals for Dropdown
  const fetchAnimals = async () => {
    try {
      const res = await fetch("https://dairy.server.statify.co.ke/api/animals");
      const data = await res.json();
      if (data.animals && Array.isArray(data.animals)) {
        setAnimals(data.animals);
      } else if (Array.isArray(data)) {
        setAnimals(data);
      }
    } catch (err) {
      console.error('Error fetching animals:', err);
    }
  };

  useEffect(() => {
    fetchHealthRecords();
    fetchAnimals();
  }, []);

  // Filter records based on search and filters
  useEffect(() => {
    if (!Array.isArray(healthRecords)) {
      setFilteredRecords([]);
      return;
    }
    
    let results = healthRecords;

    // Apply search term
    if (searchTerm) {
      results = results.filter(record =>
        (record.animal_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (record.diagnosis?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (record.vet_name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (record.treatment?.toLowerCase() || '').includes(searchTerm.toLowerCase())
      );
    }

    // Apply animal filter
    if (filters.animal_id) {
      results = results.filter(record => 
        record.animal_id.toString() === filters.animal_id
      );
    }

    // Apply diagnosis filter
    if (filters.diagnosis) {
      results = results.filter(record => 
        record.diagnosis.toLowerCase().includes(filters.diagnosis.toLowerCase())
      );
    }

    // Apply sorting
    if (sortConfig.key) {
      results.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        if (sortConfig.key === 'date' || sortConfig.key === 'follow_up_date') {
          try {
            const aDate = new Date(sortConfig.key === 'date' ? a.originalDate : a.originalFollowUpDate);
            const bDate = new Date(sortConfig.key === 'date' ? b.originalDate : b.originalFollowUpDate);
            
            if (isNaN(aDate.getTime()) || isNaN(bDate.getTime())) return 0;
            
            return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
          } catch (err) {
            return 0;
          }
        }
        
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return sortConfig.direction === 'asc' 
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
        
        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredRecords(results);
  }, [healthRecords, searchTerm, filters, sortConfig]);

  // Sort Handler
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filter Handlers
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      animal_id: "",
      diagnosis: ""
    });
    setSearchTerm("");
    setSortConfig({ key: null, direction: 'asc' });
  };

  // Form Handlers
  const handleFormChange = (field, value) => {
    setHealthForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setHealthForm({
      animal_id: "",
      diagnosis: "",
      treatment: "",
      vet_name: "",
      follow_up_date: "",
      date: new Date().toISOString().split('T')[0]
    });
  };

  // Create Health Record
  const handleCreateHealthRecord = async () => {
    if (!healthForm.animal_id || !healthForm.diagnosis) {
      swal("Error", "Animal and diagnosis are required", "error");
      return;
    }

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...healthForm,
          animal_id: parseInt(healthForm.animal_id)
        }),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Health record created successfully!", "success");
        setOpenCreateDialog(false);
        resetForm();
        fetchHealthRecords();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Update Health Record
  const handleUpdateHealthRecord = async () => {
    if (!selectedRecord) return;

    try {
      const res = await fetch(`${API_URL}/${selectedRecord.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...healthForm,
          animal_id: parseInt(healthForm.animal_id)
        }),
      });

      const data = await res.json();
      if (res.ok) {
        swal("Success", "Health record updated successfully!", "success");
        setOpenEditDialog(false);
        setSelectedRecord(null);
        resetForm();
        fetchHealthRecords();
      } else {
        swal("Error", data.error, "error");
      }
    } catch (err) {
      swal("Error", "Something went wrong", "error");
    }
  };

  // Delete Handler
  const handleDelete = async (recordId) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the health record!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${recordId}`, { method: "DELETE" });
        const data = await res.json();
        if (res.ok) {
          swal("Deleted!", data.message, "success");
          fetchHealthRecords();
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // View Handler
  const handleView = (record) => {
    setSelectedRecord(record);
    setOpenViewDialog(true);
  };

  // Open Edit Dialog - FIXED VERSION
  const handleEdit = (record) => {
    setSelectedRecord(record);
    
    // Use the helper function to safely format the dates
    const formattedDate = formatDateForInput(record.originalDate || record.date);
    const formattedFollowUpDate = formatDateForInput(record.originalFollowUpDate || record.follow_up_date);
    
    setHealthForm({
      animal_id: record.animal_id.toString(),
      diagnosis: record.diagnosis,
      treatment: record.treatment || "",
      vet_name: record.vet_name || "",
      follow_up_date: record.follow_up_date !== 'No follow-up' ? formattedFollowUpDate : "",
      date: formattedDate
    });
    setOpenEditDialog(true);
  };

  // Virtualized Table Content
  const fixedHeaderContent = () => (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="left"
          style={{ width: column.width }}
          sx={{ 
            backgroundColor: PRIMARY_COLOR, 
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '12px 8px'
          }}
        >
          <TableSortLabel
            active={sortConfig.key === column.dataKey}
            direction={sortConfig.direction}
            onClick={() => handleSort(column.dataKey)}
            sx={{ color: 'white !important' }}
          >
            {column.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  );

  const rowContent = (index, record) => (
    <React.Fragment>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {record.animal_id}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {record.animal_name}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap title={record.diagnosis}>
          {record.diagnosis}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {record.vet_name || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {record.date}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {record.follow_up_date}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={record.status} 
          size="small"
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: 
              record.status === "Completed" ? '#4caf50' :
              record.status === "Pending" ? SECONDARY_COLOR : '#f44336',
            color: 'white'
          }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
          <IconButton 
            size="small" 
            onClick={() => handleView(record)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: PRIMARY_COLOR
            }}
          >
            <ViewIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleEdit(record)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: PRIMARY_LIGHT
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton 
            size="small" 
            onClick={() => handleDelete(record.id)}
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: '#d32f2f'
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </React.Fragment>
  );

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: PRIMARY_COLOR }}>
        <Toolbar>
          <HealthIcon sx={{ mr: 2 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Health Records
          </Typography>
          <Chip 
            label={`${healthRecords.length} Records`} 
            sx={{ 
              backgroundColor: SECONDARY_COLOR, 
              color: 'white', 
              fontWeight: 'bold', 
              mr: 2 
            }}
          />
          <Button 
            variant="contained" 
            startIcon={<AddIcon />}
            onClick={() => setOpenCreateDialog(true)}
            sx={{ 
              borderRadius: 2, 
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
            New Health Record
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: PRIMARY_LIGHT }}>
          {/* Search and Filters */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Search by animal name, diagnosis, vet name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<FilterIcon />}
                    onClick={() => setShowFilters(!showFilters)}
                    variant={showFilters ? "contained" : "outlined"}
                    size="small"
                    sx={{
                      backgroundColor: showFilters ? PRIMARY_COLOR : 'transparent',
                      color: showFilters ? 'white' : PRIMARY_COLOR,
                      borderColor: PRIMARY_COLOR,
                      '&:hover': {
                        backgroundColor: showFilters ? PRIMARY_DARK : 'rgba(2, 74, 89, 0.04)',
                        borderColor: PRIMARY_DARK,
                      }
                    }}
                  >
                    Filters
                  </Button>
                  <Button 
                    onClick={resetFilters} 
                    variant="outlined" 
                    size="small" 
                    sx={{
                      color: PRIMARY_COLOR,
                      borderColor: PRIMARY_COLOR,
                      '&:hover': {
                        borderColor: PRIMARY_DARK,
                        backgroundColor: 'rgba(2, 74, 89, 0.04)',
                      }
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Expandable Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl
                      fullWidth
                      sx={{
                        minWidth: 250,
                      }}
                    >
                      <InputLabel id="animal-select-label">Animal</InputLabel>
                      <Select
                        labelId="animal-select-label"
                        value={filters.animal_id}
                        onChange={(e) => handleFilterChange('animal_id', e.target.value)}
                        label="Animal"
                        sx={{
                          width: '100%',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <MenuItem value="">All Animals</MenuItem>
                        {animals.map((animal) => (
                          <MenuItem key={animal.id} value={animal.id.toString()}>
                            {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Diagnosis"
                      value={filters.diagnosis}
                      onChange={(e) => handleFilterChange('diagnosis', e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Content Area */}
          <Box sx={{ p: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress sx={{ color: PRIMARY_COLOR }} />
              </Box>
            ) : filteredRecords.length === 0 ? (
              <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: PRIMARY_LIGHT }}>
                <CardContent>
                  <AnimalIcon sx={{ fontSize: 64, color: PRIMARY_COLOR, mb: 2 }} />
                  <Typography variant="h5" sx={{ color: PRIMARY_COLOR }} gutterBottom>
                    No health records found
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    Start tracking your herd's health by recording diagnoses and treatments
                  </Typography>
                  <Button 
                    variant="contained" 
                    onClick={() => setOpenCreateDialog(true)} 
                    size="large"
                    sx={{
                      backgroundColor: SECONDARY_COLOR,
                      '&:hover': {
                        backgroundColor: '#e59400'
                      }
                    }}
                  >
                    Create First Record
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: PRIMARY_LIGHT, borderRadius: 1 }}>
                <TableVirtuoso
                  data={filteredRecords}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </Paper>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Create Health Record Dialog */}
      <Dialog 
        open={openCreateDialog} 
        onClose={() => setOpenCreateDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: PRIMARY_COLOR, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <AddIcon sx={{ mr: 1 }} />
            Create New Health Record
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                sx={{
                  minWidth: { xs: '100%', sm: 250, md: 300 },
                }}
              >
                <InputLabel id="animal-select-label">Animal *</InputLabel>
                <Select
                  labelId="animal-select-label"
                  value={healthForm.animal_id}
                  onChange={(e) => handleFormChange('animal_id', e.target.value)}
                  label="Animal *"
                  sx={{
                    width: '100%',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {animals.map((animal) => (
                    <MenuItem key={animal.id} value={animal.id.toString()}>
                      {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Record Date"
                type="date"
                value={healthForm.date}
                onChange={(e) => handleFormChange('date', e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Diagnosis *"
                value={healthForm.diagnosis}
                onChange={(e) => handleFormChange('diagnosis', e.target.value)}
                placeholder="Enter the diagnosis or health issue..."
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Treatment"
                placeholder="Describe the treatment plan, medications, and procedures..."
                value={healthForm.treatment}
                onChange={(e) => handleFormChange('treatment', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Veterinarian Name"
                placeholder="Dr. Smith"
                value={healthForm.vet_name}
                onChange={(e) => handleFormChange('vet_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Follow-up Date"
                type="date"
                value={healthForm.follow_up_date}
                onChange={(e) => handleFormChange('follow_up_date', e.target.value)}
                InputLabelProps={{ shrink: true }}
                helperText="Optional follow-up appointment"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCreateDialog(false)}>Cancel</Button>
          <Button 
            onClick={handleCreateHealthRecord} 
            variant="contained" 
            disabled={!healthForm.animal_id || !healthForm.diagnosis}
            sx={{
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
            Create Record
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Health Record Dialog */}
      <Dialog 
        open={openEditDialog} 
        onClose={() => setOpenEditDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: PRIMARY_COLOR, color: 'white' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <EditIcon sx={{ mr: 1 }} />
            Edit Health Record
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Animal *</InputLabel>
                <Select
                  value={healthForm.animal_id}
                  onChange={(e) => handleFormChange('animal_id', e.target.value)}
                  label="Animal *"
                >
                  {animals.map(animal => (
                    <MenuItem key={animal.id} value={animal.id.toString()}>
                      {animal.name || `Animal ${animal.id}`} ({animal.tag_number})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Record Date"
                type="date"
                value={healthForm.date}
                onChange={(e) => handleFormChange('date', e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Diagnosis *"
                value={healthForm.diagnosis}
                onChange={(e) => handleFormChange('diagnosis', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Treatment"
                value={healthForm.treatment}
                onChange={(e) => handleFormChange('treatment', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Veterinarian Name"
                value={healthForm.vet_name}
                onChange={(e) => handleFormChange('vet_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Follow-up Date"
                type="date"
                value={healthForm.follow_up_date}
                onChange={(e) => handleFormChange('follow_up_date', e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
          <Button 
            onClick={handleUpdateHealthRecord} 
            variant="contained" 
            disabled={!healthForm.animal_id || !healthForm.diagnosis}
            sx={{
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
            Update Record
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Health Record Dialog */}
      <Dialog 
        open={openViewDialog} 
        onClose={() => setOpenViewDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ViewIcon sx={{ mr: 1 }} />
              Health Record Details
            </Box>
            <IconButton onClick={() => setOpenViewDialog(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedRecord && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Animal Information
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Animal ID:</strong> {selectedRecord.animal_id}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Animal Name:</strong> {selectedRecord.animal_name}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Record Details
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Date:</strong> {selectedRecord.date}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Veterinarian:</strong> {selectedRecord.vet_name || 'Not specified'}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Status:</strong> 
                      <Chip 
                        label={selectedRecord.status} 
                        size="small"
                        sx={{ 
                          ml: 1,
                          backgroundColor: 
                            selectedRecord.status === "Completed" ? '#4caf50' :
                            selectedRecord.status === "Pending" ? SECONDARY_COLOR : '#f44336',
                          color: 'white'
                        }}
                      />
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Diagnosis
                    </Typography>
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                      {selectedRecord.diagnosis}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                      Treatment
                    </Typography>
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                      {selectedRecord.treatment || 'No treatment recorded'}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              {selectedRecord.follow_up_date !== 'No follow-up' && (
                <Grid item xs={12}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ color: PRIMARY_COLOR }}>
                        Follow-up Information
                      </Typography>
                      <Typography variant="body2">
                        <strong>Follow-up Date:</strong> {selectedRecord.follow_up_date}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenViewDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Add FAB for mobile */}
      <Fab
        aria-label="add"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'flex', md: 'none' },
          backgroundColor: PRIMARY_COLOR,
          '&:hover': {
            backgroundColor: PRIMARY_DARK
          }
        }}
        onClick={() => setOpenCreateDialog(true)}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default HealthRecordsPage;